const urlHelpers = require('../helpers/urlHelpers');

function safelyRefreshSwiper(swiperInstance) {
    if (!swiperInstance || swiperInstance.destroyed) {
        return;
    }

    if (typeof swiperInstance.update === 'function') {
        swiperInstance.update(true);
        return;
    }

    if (typeof swiperInstance.updateSlidesSize === 'function') {
        swiperInstance.updateSlidesSize();
    }

    if (typeof swiperInstance.updateSlidesOffset === 'function') {
        swiperInstance.updateSlidesOffset();
    }

    if (typeof swiperInstance.onResize === 'function') {
        swiperInstance.onResize();
    }
}

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
}

/**
 * Replace DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function replaceDom($results, selector) {
    var $updates = $results.filter(selector).add($results.find(selector)).first();

    if ($updates.length) {
        $(selector).replaceWith($updates);
    }
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    var openRefinements = [];

    $('.refinements').each(function () {
        openRefinements.push($(this).find('.refinement').filter(function () {
            return $(this).find('.card-body').hasClass('refinement-visibility');
        }).map(function () {
            return $(this).data('display-name');
        }).get());
    });

    updateDom($results, '.refinements');

    $('.refinements').each(function (index) {
        $(this).find('.refinement').each(function () {
            var $refinement = $(this);
            var isOpen = openRefinements[index].indexOf($refinement.data('display-name')) !== -1;
            var hasSelectedValue = $refinement.closest('.js-filter-modal').length && $refinement.find('.selected').length;

            if (isOpen || hasSelectedValue) {
                $refinement.find('.card-body').addClass('refinement-visibility');
                $refinement.find('.card-header svg.chevron').addClass('flip');
            }
        });
    });
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements,
        '.grid-footer': replaceDom
    };

    // Update DOM elements that do not require special handling
    [
        '.product-result-bar.grid-header',
        '.header-bar',
        '.header.page-title',
        '.product-grid',
        '.filter-bar',
        '.mobile-results-summary'
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
}


/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}

/**
 * Updates the visible PLP result count after appending more product tiles.
 *
 * @return {undefined}
 */
function updateRenderedProductCount() {
    var visibleProducts = $('.product-grid .product-grid-tile').length;
    var totalProducts = parseInt($('.grid-footer').data('hit-count'), 10);

    if (!totalProducts) {
        return;
    }

    $('.search-result-count').text('Showing ' + Math.min(visibleProducts, totalProducts) + ' of ' + totalProducts);
}

/**
 * Appends the next PLP product page without changing browser history.
 *
 * @param {string} response - Rendered product grid partial
 * @return {undefined}
 */
function appendProductGridPage(response) {
    var $results = $(response);
    var $newTiles = $results.filter('.product-grid-tile').add($results.find('.product-grid-tile'));
    var $newFooter = $results.filter('.grid-footer').add($results.find('.grid-footer')).first();
    var $currentFooter = $('.product-grid > .grid-footer').last();

    if ($currentFooter.length) {
        $currentFooter.before($newTiles);
        $currentFooter.replaceWith($newFooter);
    } else {
        $('.product-grid').append($newTiles).append($newFooter);
    }

    updateRenderedProductCount();
    updateSortOptions(response);
}

function initalizeSelect2() {
    $('.form-select').select2({
        minimumResultsForSearch: -1,
        dropdownCssClass: 'select2-dropdown__custom'
    });
}

/**
 * Update total count of search results in mobile modal
 *
 * @param {string} response - Updated rendered HTML
 * @return {undefined}
 */
function updateMobileSearchTotalCount(response) {
    var htmlResults = $.parseHTML(response);
    var $tempDom = $('<div>').append(htmlResults.find(element => $(element).hasClass('product-search-header')));
    var counterHtml = $tempDom.find('.search-result-counter');
    $('body .search-result-counter').empty().html(counterHtml);
}

module.exports = {
    initializeSelect2: initalizeSelect2,

    filter: function () {
        // Display refinements bar when Menu icon clicked
        $('.container').on('click', 'button.filter-results', function () {
            $('.refinement-bar, .modal-background').show();
            $('.refinement-bar').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', true);
            $('.refinement-bar .close').focus();
        });
    },

    removeSelect2Title: function () {
        // Remove Select2 title
        $(document).on('mouseenter', '.select2-selection__rendered',  function () {
            $(this).removeAttr('title');
        });
    },

    closeRefinements: function () {
        // Refinements close button
        $('.container').on('click', '.refinement-bar button.close, .modal-background', function () {
            $('.refinement-bar, .modal-background').hide();
            $('.refinement-bar').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
            $('.btn.filter-results').focus();
        });
    },

    resize: function () {
        // Close refinement bar and hide modal background if user resizes browser
        $(window).resize(function () {
            $('.refinement-bar, .modal-background').hide();
            $('.refinement-bar').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
        });
    },

    sort: function () {
        // Handle sort order menu selection
        $('.container').on('change', 'select#searchResultSelect', function (e) {
            e.preventDefault();
            var selectedValue = $(this).find('option:selected').text().trim();
            $.spinner().start();
            $(this).trigger('search:sort', this.value);

            $.ajax({
                url: this.value,
                data: { selectedUrl: this.value },
                method: 'GET',
                success: function (response) {
                    parseResults(response);
                    initalizeSelect2();
                    updateMobileSearchTotalCount(response);

                    $.spinner().stop();
                    $('body').trigger('gtm:plpSort', { selectedValue: selectedValue });
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    showMore: function () {
        // Show more products
        $('.container').on('click', '.show-more button', function (e) {
            e.stopPropagation();
            var showMoreUrl = $(this).data('url');
            e.preventDefault();

            $.spinner().start();
            $(this).trigger('search:showMore', e);
            $.ajax({
                url: showMoreUrl,
                data: { selectedUrl: showMoreUrl },
                method: 'GET',
                success: function (response) {
                    appendProductGridPage(response);
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    applyFilter: function () {
        // Handle refinement value selection and reset click
        $(document).on(
            'click',
            '.refinements li button, .refinements li a, .filter-reset button.reset, .filter-reset a.reset, .filter-value button, .swatch-filter button, .refinement .bin-icon',
            function (e) {
                e.preventDefault();
                e.stopPropagation();

                $.spinner().start();
                var $this = $(this);
                $this.trigger('search:filter', e);
                var isMobile = $this.parents('.js-filter-modal').length != 0;
                var attributeId = '#' + $this.find('span').last().attr('id');

                var target = $this.data('href');
                history.replaceState({}, '', target);

                $.ajax({
                    url: urlHelpers.appendParamToUrl(target, 'format', 'ajax'),
                    data: {
                        selectedUrl: $this.data('href')
                    },
                    method: 'GET',
                    success: function (response) {
                        parseResults(response);
                        initalizeSelect2();
                        updateMobileSearchTotalCount(response);
                        $(attributeId).parent('button').focus();
                        $.spinner().stop();
                        
                        // If on mobile view, display show products button
                        if (isMobile) {
                            $('.js-filter-modal').find('.show-products-btn').removeClass('d-none');
                        }
                        if (!$this.find('input[type="checkbox"]:checked').length) {
                            $('body').trigger('gtm:plpApplyFilters', {
                                target: $this
                            });
                        }
                    },
                    error: function () {
                        $(attributeId).parent('button').focus();
                        $.spinner().stop();
                    }
                });
            });
    },

    showProductsBtn: function () {
        $('.js-filter-modal').on('click', '.show-products-btn', function () {
            $('.js-filter-modal').find('.close-modal > svg').trigger('click');
        });
    },

    showContentTab: function () {
        // Display content results from the search
        $('.container').on('click', '.content-search', function () {
            if (!$('.product-search-header').hasClass('d-none')) {
                $('.product-search-header').addClass('d-none');
            }
        });

        // Display product results from the search
        $('.container').on('click', '.product-search', function () {
            if ($('.product-search-header').hasClass('d-none')) {
                $('.product-search-header').removeClass('d-none');
            }
        });
    },

    triggerSelectChange: function () {
        $(document).on('select2:select', '#searchResultSelect', function (e) {
            var $originalElement = e.params.data.element;
            $.spinner().start();
            $(this).trigger('search:sort', $originalElement.value);
            $.ajax({
                url: $originalElement.value,
                data: { selectedUrl: $originalElement.value },
                method: 'GET',
                success: function (response) {
                    parseResults(response);
                    initalizeSelect2();
                    updateMobileSearchTotalCount(response);
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    applySortOnModal: function () {
        $(document).on('click', '.sort-order-modal p', function () {
            var $target = $(this);
            var value = $target.data('value');
            var $modal = $target.closest('.modal');
            $.spinner().start();
            $target.trigger('search:sort', value);
            $.ajax({
                url: value,
                data: { selectedUrl: value },
                method: 'GET',
                success: function (response) {
                    parseResults(response);
                    initalizeSelect2();
                    updateMobileSearchTotalCount(response);
                    $('.sort-order-modal p.selected').removeClass('selected');
                    $target.addClass('selected');

                    if ($modal) {
                        setTimeout(function () {
                            $modal.modal('hide');
                        }, 750);
                    }
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    expandRefinements: function ()  {
        $(document).on('click', '.refinement .card-header-title', function () {
            $(this).children('svg.chevron').toggleClass('flip');
            $(this).closest('.refinement').find('.card-body').toggleClass('refinement-visibility');
        });
    },

    refinementModal: function () {
        $(document).on('click', '.js-refinement-modal a', function (e) {
            e.preventDefault();
            var target = $(this).data('target');
            $(target).modal('show');
        });
    },

    closeModal: function () {
        $(document).on('click', '.close-modal', function () {
            $(this).closest('.modal').modal('hide');

            if ($(this).parents('.js-filter-modal').length != 0) {
                $('.js-filter-modal .show-products-btn').addClass('d-none');
            }
        });
    },

    searchSwiper: function () {
        var Swiper = require('swiper');
        var slideThreshold = 4;
        var swiperSlideCount = $('.swiper-recommendations .product').length;
        var isSwiperSlideCountOverThreshold = swiperSlideCount > slideThreshold;
        var slidesPerView = isSwiperSlideCountOverThreshold ? slideThreshold : swiperSlideCount;

        var recommendationsSwiper = new Swiper('.swiper-recommendations', {
            zoom: false,
            pagination: '.swiper-pagination-recommendations',
            slidesPerView: slidesPerView,
            centeredSlides: false,
            paginationClickable: true,
            keyboardControl: false,
            grabCursor: true,
            nextButton: '.swiper-button-next',
            prevButton: '.swiper-button-prev',
            loop: isSwiperSlideCountOverThreshold,
            onInit: function () {
                if (!isSwiperSlideCountOverThreshold) {
                    $('.swiper-button-prev').hide();
                    $('.swiper-button-next').hide();
                }
            },
            onAfterResize: function () {
                safelyRefreshSwiper(recommendationsSwiper);
            },
            breakpoints: {
                584: {
                    slidesPerView: swiperSlideCount > 1 ? 1.5 : 1,
                    centeredSlides: true
                },
                768: {
                    slidesPerView: swiperSlideCount > 2 ? 2.5 : swiperSlideCount - 0.5,
                    centeredSlides: isSwiperSlideCountOverThreshold
                },
                1024: {
                    slidesPerView: swiperSlideCount > 3 ? 2.5 : swiperSlideCount - 0.5,
                    centeredSlides: isSwiperSlideCountOverThreshold
                }
            }
        });
        var viewSize = $(window).width();
        if (viewSize < 584) {
            if (swiperSlideCount > 1) {
                slidesPerView = 1.5;
            }
            else {
                slidesPerView = 1;
            }
        } else if ((viewSize >= 584) && (viewSize < 768)) {
            if (swiperSlideCount > 2) {
                slidesPerView = 2.5;
            }
            else {
                slidesPerView = swiperSlideCount - 0.5;
            }
        } else if ((viewSize >= 7688) && (viewSize < 1024)) {
            if (swiperSlideCount > 2) {
                slidesPerView = 2.5;
            }
            else {
                slidesPerView = swiperSlideCount - 0.5;
            }
        }

        // add the data outofinitview equal to true to the elements that are not visible
        $('.swiper-recommendations').attr('numberSlides', slidesPerView);
        var swiper = $('.swiper-recommendations');
        var items = swiper.find('.swiper-slide');
        var firstVisiblePos = swiper.find('.swiper-slide-active').index();
        var lastVisiblePos =  firstVisiblePos + slidesPerView;
        for (var i = 0; i < items.length; i++) {
            if (i < firstVisiblePos || i >= lastVisiblePos) {
                items.eq(i).attr('data-outofinitview', true);
            }
        }

        $(window).on('resize', function () {
            safelyRefreshSwiper(recommendationsSwiper);
        });
    },

    categoryDescriptionSeeMore: function () {
        $(document).on('click', '.search-description-button', function () {
            var $categoryDescription = $('.category-description');
            $categoryDescription.toggleClass('expand');
            var description = $categoryDescription.data('description');

            if ($categoryDescription.hasClass('expand') && description) {
                $categoryDescription.html(description);
                $(this).addClass('col mt-1');
                $(this).text('See less');
                $('.search-results-description').addClass('flex-column');
            } else {
                $categoryDescription.html(description.substring(0, 76) + '...');
                $(this).removeClass('col mt-1');
                $(this).text('See more');
                $('.search-results-description').removeClass('flex-column');
            }
        });
    },
};
